window.addEventListener('DOMContentLoaded', (event) => {
    (function() {
      const updateVariantDisplay = (variant = null) => {
        const selectedVariant = document.querySelector('.selected-variant');
        if (variant) {
          selectedVariant.innerHTML = selectedVariant ? ': ' + variant.getAttribute('data-variant-name') : '';
        } else {
          selectedVariant.innerHTML = ': ' + document.querySelector('.product__form-container .selector-wrapper ul li input:checked').value;
        }
      };
      document.querySelectorAll('.product-form__item .options-list.color li:not(.hide-element-mobile)').forEach(variant => {
        variant.addEventListener('mouseenter', () => updateVariantDisplay(variant));
        variant.addEventListener('mouseleave', () => updateVariantDisplay());
        variant.addEventListener('click', () => updateVariantDisplay(variant));
      });
      updateVariantDisplay();
      document.querySelectorAll('.product-form__item .options-list li.hide-element-mobile').forEach(hiddenElement => {
        hiddenElement.addEventListener("click", (event) => {
          const listItem = event.target.closest('li.hide-element-mobile');
          if (listItem) {
            listItem.remove();
          }
          document.querySelectorAll('[hide-element-mobile]').forEach(hiddenElement => {
            hiddenElement.removeAttribute('hide-element-mobile');
          });
        });
      })
  
      const isDesktop = window.innerWidth > 768;
      if (isDesktop) {
        const containers = document.querySelectorAll('.product__media-container');
  
        containers.forEach(con => {
          let img = con.querySelector('.product-image');
          let lens = con.querySelector('.zoom-lens');
          let result = con.querySelector('.zoom-result');
  
          if (!img || !lens || !result) return; // Ensure all elements exist
  
          con.addEventListener('mousemove', (event) => zoom(event, img, lens, result));
          con.addEventListener('mouseenter', () => {
            lens.style.display = 'block';
            result.style.display = 'block';
          });
          con.addEventListener('mouseleave', () => {
            lens.style.display = 'none';
            result.style.display = 'none';
          });
        });
  
        function zoom(event, img, lens, result) {
          const { offsetX, offsetY } = event;
          const imageWidth = img.getAttribute('width');
          const imageHeight = img.getAttribute('height');
          const { offsetWidth: lensWidth, offsetHeight: lensHeight } = lens;
  
          let lensX = offsetX - lensWidth / 2;
          let lensY = offsetY - lensHeight / 2;
  
          lensX = Math.max(0, Math.min(imageWidth - lensWidth, lensX));
          lensY = Math.max(0, Math.min(imageHeight - lensHeight, lensY));
  
          lens.style.left = `${lensX}px`;
          lens.style.top = `${lensY}px`;
  
          const fx = (result.offsetWidth / lensWidth) * 0.3;
          const fy = (result.offsetHeight / lensHeight) * 0.3;
  
          const xPercent = (lensX / imageWidth) * 100;
          const yPercent = (lensY / imageHeight) * 100;
  
          result.style.backgroundImage = `url(${img.getAttribute('src')})`;
          result.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
  
          result.style.backgroundSize = `${imageWidth * fx}px ${imageHeight * fy}px`;
        }
      }
    })();
  });